<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold"
          >manage suppliers</small
        >
      </legend>
      <div></div>
      <div>
        <div class="suppliersLoader">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          <i
            class="fa fa-spinner fa-spin"
            style="font-size: 24px; color: blue"
          ></i
          >Loading suppliers...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemSuppliers"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit truck!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewSupplier(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit Supplier
              </button>
            </span>
            <span v-else>{{ props.formattedRow[props.column.field] }}</span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Supplier name",
          field: "supplier_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter supplier",
          },
        },
        {
          label: "Contact person",
          field: "contact_person",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter contact person",
          },
        },
        {
          label: "Phone number",
          field: "phone_number",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter phone number",
          },
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true,
          filterOptions: {
            enabled: true, // enable filter for this column
          },
        },
      ],
    };
  },
  created() {
    this.loadSuppliers();
  },
  computed: {
    ...mapGetters(["systemSuppliers"]),
  },
  methods: {
    ...mapActions(["loadSuppliers", "viewSupplier"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/suppliers/managesuppliers.vue